<template>
  <button
    :aria-label="ariaLabel || $t('common.back')"
    aria-haspopup="true"
    aria-expanded="false"
    class="btn btn--clean trigger"
    tabindex="-1"
    @click="onClick"
  >
    <i class="trigger fa fa-chevron-left" tabindex="-1" :aria-label="ariaLabel"></i>
  </button>
</template>

<script>
export default {
  props: {
    ariaLabel: String,
  },
  methods: {
    onClick(e) {
      this.$emit('click', e)
    },
  },
}
</script>
<style lang="scss" scoped>
i.trigger:focus, button.trigger:focus {
  outline: 3px solid #EA5D4E;
  border-radius: 0;
}
</style>
